module.exports = __webpack_public_path__ + "static/media/thl-1.071d379e.png";